import { jsxs as p, jsx as o } from "react/jsx-runtime";
import { memo as H, useRef as I, useState as V, useMemo as k } from "react";
import { FileList as q } from "./index62.mjs";
import { useDropzoneState as w } from "./useDropzoneState.mjs";
import { isDefined as G } from "./types3.mjs";
import { Typography as J } from "./index59.mjs";
import { getAcceptFromValidation as K } from "./utils3.mjs";
import { useLocale as M } from "./useLocale.mjs";
import { UploadContainer as N, UploadRC as Q, UploadIcon as W, UploadContent as X, Placeholder as Y, HelperTextSlot as Z, StyledDropzoneError as _, FileListSlot as oo } from "./styles39.mjs";
const co = H(
  ({
    isMultiple: s = !0,
    fileList: m,
    size: i = "default",
    error: r,
    fileStyle: f = "outlined",
    defaultFileList: h,
    onProgress: D,
    onSuccess: g,
    onStart: u,
    onError: U,
    onChange: S,
    onDelete: y,
    helperText: t,
    validation: a,
    disabled: e,
    onDownload: $,
    onPreview: z,
    onReload: L,
    placeholder: E,
    isDownloadable: C,
    ...v
  }) => {
    const d = I(null), F = M("dropzone"), [P, T] = V(), {
      fileList: c,
      handleUploadProgress: b,
      handleUploadStart: j,
      handleUploadSuccess: O,
      handleUploadError: R,
      handleUploadDelete: x,
      handleUploadBefore: A
    } = w({
      onProgress: D,
      onStart: u,
      onSuccess: g,
      onError: U,
      onChange: S,
      onDelete: y,
      ref: d,
      validation: a,
      isMultiple: s,
      fileListOuter: m,
      defaultFileList: h
    }), l = (n) => {
      (n.type !== "dragleave" || !n.currentTarget.contains(n.relatedTarget)) && T(n.type);
    }, B = k(
      () => K(a),
      [a]
    );
    return /* @__PURE__ */ p(
      N,
      {
        onDragLeave: l,
        onDragOver: l,
        onDrop: l,
        "data-testid": "dropzone-container",
        children: [
          /* @__PURE__ */ p(
            Q,
            {
              onSuccess: O,
              onError: R,
              onProgress: b,
              onStart: j,
              beforeUpload: A,
              multiple: s,
              $isDragOver: P === "dragover",
              ref: d,
              accept: B,
              name: "dropzone-input",
              disabled: e,
              $size: i,
              $hasError: !!r,
              ...v,
              children: [
                /* @__PURE__ */ o(W, { $isDisabled: e, $hasError: !!r }),
                /* @__PURE__ */ p(X, { $size: i, children: [
                  /* @__PURE__ */ o(Y, { component: "span", $isDisabled: e, children: E || F.placeholder }),
                  G(t) && /* @__PURE__ */ o(Z, { $isDisabled: e, children: typeof t == "string" ? /* @__PURE__ */ o(J.Caption, { component: "p", children: t }) : t })
                ] })
              ]
            }
          ),
          r && /* @__PURE__ */ o(_, { children: r }),
          c.length > 0 && /* @__PURE__ */ o(oo, { children: /* @__PURE__ */ o(
            q,
            {
              files: c,
              fileStyle: f,
              onDelete: x,
              onDownload: $,
              onPreview: z,
              onReload: L,
              isDisabled: e,
              isDownloadable: C,
              isDeletable: !0
            }
          ) })
        ]
      }
    );
  }
);
export {
  co as Dropzone
};
//# sourceMappingURL=index60.mjs.map
